const wordCounter = text => {
  if (text === null || text === undefined || text === '') {
    return 0
  }
  return (text.match(/\S+/g) || []).length
}
const contentWordCount = content => {
  let totalWordCount = 0
  totalWordCount += wordCounter(content.htmlTitle)
  totalWordCount += wordCounter(content.htmlMetaDescription)
  totalWordCount += wordCounter(content.title)
  totalWordCount += wordCounter(content.content)
  totalWordCount += wordCounter(content.summary)
  totalWordCount += wordCounter(content.bonusReview)
  totalWordCount += wordCounter(content.gameSelectionReview)
  if (content.pros) {
    content.pros.forEach(pro => {
      totalWordCount += wordCounter(pro)
    })
  }
  if (content.cons) {
    content.cons.forEach(con => {
      totalWordCount += wordCounter(con)
    })
  }
  if (content.faq) {
    totalWordCount += wordCounter(content.faq.title)
    if (content.faq.questions) {
      content.faq.questions.forEach(qa => {
        totalWordCount += wordCounter(qa.question)
        totalWordCount += wordCounter(qa.answer)
      })
    }
  }
  if (content.howTo) {
    totalWordCount += wordCounter(content.howTo.headline)
    totalWordCount += wordCounter(content.howTo.description)
    totalWordCount += wordCounter(content.howTo.time)
    totalWordCount += wordCounter(content.howTo.tool)
    totalWordCount += wordCounter(content.howTo.supply)
    if (content.howTo.steps) {
      content.howTo.steps.forEach(step => {
        totalWordCount += wordCounter(step.headline)
        totalWordCount += wordCounter(step.name)
        totalWordCount += wordCounter(step.description)
      })
    }
  }
  if (content.site.id === 'casinobernie' && content.prosConsShortcode) {
    totalWordCount += wordCounter(content.prosConsShortcode.headline)
    totalWordCount += wordCounter(content.prosConsShortcode.description)
    if (content.prosConsShortcode.pros) {
      content.prosConsShortcode.pros.forEach(pro => {
        totalWordCount += wordCounter(pro.item)
      })
    }
    if (content.prosConsShortcode.cons) {
      content.prosConsShortcode.cons.forEach(con => {
        totalWordCount += wordCounter(con.item)
      })
    }
  }
  return totalWordCount
}
const contentListWordCount = contentList => {
  let totalWordCount = 0
  for (let i = 0; i < contentList.length; i++) {
    totalWordCount += contentWordCount(contentList[i].content.userData)
  }
  return totalWordCount
}

module.exports = {
  wordCounter,
  contentWordCount,
  contentListWordCount,
}
